import React, { useEffect, useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import Loader from "../../../../../../../../components/Loaders/Loader";
import { useTranslation } from "react-i18next";
import AttributesItem from "./attributeItem";
import { useStyles } from "../../../../../Styles/style";
import AddIcon from "@mui/icons-material/Add";
import { Dialog } from "@material-ui/core";
import ConfirmModal from "../../../../../../../../components/Models/ConfirmationModal";

const platforms = [
  {
    name: "attributes/url_facebook",
    regex: /^https:\/\/(www\.)?facebook\.com\/([a-zA-Z0-9._]+)\/?$/,
    error: false,
    helperText: ["https://www.facebook.com/{username}"],
  },
  {
    name: "attributes/url_instagram",
    regex: /^https:\/\/(www\.)?instagram\.com\/([a-zA-Z0-9._]+)\/?$/,
    error: false,
    helperText: ["https://www.instagram.com/{username}"],
  },
  {
    name: "attributes/url_pinterest",
    regex: /^https:\/\/(www\.)?pinterest\.com\/([a-zA-Z0-9._-]+)\/?$/,
    error: false,
    helperText: ["https://www.pinterest.com/{username}"],
  },
  {
    name: "attributes/url_linkedin",
    regex:
      /^https:\/\/(www\.)?linkedin\.com\/(in|company)\/([a-zA-Z0-9-]+)\/?$/,
    error: false,
    helperText: [
      "https://www.linkedin.com/in/{username}",
      "https://www.linkedin.com/company/{username}",
    ],
  },
  {
    name: "attributes/url_twitter",
    regex: /^https:\/\/(www\.)?(twitter|x)\.com\/([a-zA-Z0-9_]+)\/?$/,
    error: false,
    helperText: [
      "https://www.twitter.com/{username}",
      "https://www.x.com/{username}",
    ],
  },
  {
    name: "attributes/url_youtube",
    regex: /^https:\/\/(www\.)?youtube\.com\/(@)[a-zA-Z0-9_-]+\/?$/,
    error: false,
    helperText: ["https://www.youtube.com/@{username}"],
  },
  {
    name: "attributes/url_tiktok",
    regex: /^https:\/\/(www\.)?tiktok\.com\/@([a-zA-Z0-9._-]+)\/?$/,
    error: false,
    helperText: ["https://www.tiktok.com/{username}"],
  },
  {
    name: "attributes/url_menu",
    regex: /^https:\/\/.*/,
    error: false,
    helperText: ["https://{website}..."],
  },
  {
    name: "attributes/url_order_ahead",
    regex: /^https:\/\/.*/,
    error: false,
    helperText: ["https://{website}..."],
  },
  {
    name: "attributes/url_reservations",
    regex: /^https:\/\/.*/,
    error: false,
    helperText: ["https://{website}..."],
  },
];

const AttributesModal = ({
  onCancel,
  locationDetailsData,
  location,
  getLocationDetails,
  allAttributes,
  touchedValue,
  setTouchedValue,
  setDisplayConfirmationBox,
  displayConfirmationBox,
  setLocationDetailsData,
  indexValue,
  setSelectedTab,
  selectedTab,
  getLocationDetailsListing,
  handleClose,
  handleUpdateAttributes,
  cancelState,
  isLoading,
  itemsArr,
  setItemsArr,
  enumRequired,
  setEnumRequired,
  urlRequired,
  setUrlRequired,
  repeatedEnumRequired,
  setRepeatedEnumRequired,
  urlValidation,
  setUrlValidation,
  filteredItemsArr,
  handleChangeAttributeValue,
  setSelectedItem,
  selectedItem,
  handleChangeSwitch,
  removeAttribute,
  handleChangeURL,
  handleChangeEnum,
  handleChangeRepeatedEnum,
  handleRepeatedEnumSwitch,
  hasEmpty,
  handleAddNewData,
  url,
  enums,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [urlPlatforms, setUrlPlatforms] = useState(platforms);

  useEffect(() => {
    const error = urlPlatforms.filter((platform) => platform?.error === true);
    if (error?.length > 0) {
      setUrlValidation(true);
    } else {
      setUrlValidation(false);
    }
  }, [urlPlatforms]);

  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      {displayConfirmationBox && (
        <Dialog
          // fullScreen={fullScreen}
          open={displayConfirmationBox}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <ConfirmModal
            title={t("Delete_Bulk_Posts")}
            description={t("Delete_post_subhead")}
            onConfirm={handleUpdateAttributes}
            onClose={handleClose}
            onCancel={onCancel}
            indexValue={indexValue}
            setSelectedTab={setSelectedTab}
            cancelState={cancelState}
            touchedValue={touchedValue}
            setTouchedValue={setTouchedValue}
            getLocationDetails={getLocationDetails}
            location={location}
            //  loading={setIsLoading}
          />
        </Dialog>
      )}

      <Grid container>
        {isLoading ? (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ padding: "18px", paddingTop: "50px", width: "550px" }}
            >
              <Loader />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {/*    {displayConfirmationBox===true && (
                <Grid xs={12} sm={12} md={12} lg={12} sx={{ margin: "5px" }}>
                  <Alert
                    mt={2}
                    mb={1}
                    severity="error"
                    // sx={{ bgcolor: "#FFD0D0", color: "#330404" }}
                  >
                    Your current changes are not saved. Please save and
                    continue.
                  </Alert>
                </Grid>
              )} */}
              {console.log(itemsArr, "itemsArr")}

              {itemsArr.length > 0 &&
                itemsArr?.map((item, index) => {
                  const result = allAttributes?.find(
                    (data) => data?.parent === item?.name
                  );
                  return (
                    <>
                      <AttributesItem
                        urlPlatforms={urlPlatforms}
                        setUrlPlatforms={setUrlPlatforms}
                        enumRequired={enumRequired}
                        setEnumRequired={setEnumRequired}
                        urlRequired={urlRequired}
                        setUrlRequired={setUrlRequired}
                        repeatedEnumRequired={repeatedEnumRequired}
                        setRepeatedEnumRequired={setRepeatedEnumRequired}
                        urlValidation={urlValidation}
                        setUrlValidation={setUrlValidation}
                        allAttributes={allAttributes}
                        result={result}
                        item={item}
                        index={index}
                        setItemsArr={setItemsArr}
                        itemsArr={itemsArr}
                        filteredItemsArr={filteredItemsArr}
                        handleChangeAttributeValue={handleChangeAttributeValue}
                        setSelectedItem={setSelectedItem}
                        selectedItem={selectedItem}
                        handleChangeSwitch={handleChangeSwitch}
                        removeAttribute={removeAttribute}
                        handleChangeURL={handleChangeURL}
                        handleChangeEnum={handleChangeEnum}
                        handleChangeRepeatedEnum={handleChangeRepeatedEnum}
                        handleRepeatedEnumSwitch={handleRepeatedEnumSwitch}
                      />
                    </>
                  );
                })}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                mb={2}
                sx={{ marginTop: "10px" }}
              >
                <Button
                  autoFocus
                  disabled={hasEmpty || urlRequired || enumRequired}
                  onClick={handleAddNewData}
                  className={
                    hasEmpty || urlRequired || enumRequired
                      ? classes.addButtonDisabled
                      : classes.addButton
                  }
                >
                  <AddIcon
                    fontSize="medium"
                    className={
                      hasEmpty || urlRequired || enumRequired
                        ? classes.addIconDisabled
                        : classes.addIcon
                    }
                  />{" "}
                  <Typography
                    className={
                      hasEmpty || urlRequired || enumRequired
                        ? classes.addButtonDisabled
                        : classes.addButton
                    }
                  >
                    {t("Add_new_attribute")}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default AttributesModal;
